(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["muster-welcome-signup"] && !Shopify.designMode) return;
  try {
    
(function () {
  const sessionKey = 'ml-welcome-popup-seen-v1';
  const dismissalKey = 'ml-welcome-popup-dismissed-v1';
  const successKey = 'ml-welcome-popup-success-v1';
  const day = 24 * 60 * 60 * 1000;
  let shownThisPage = false;

  function readStorage(key, persistent) {
    try {
      return (persistent ? window.localStorage : window.sessionStorage).getItem(key);
    } catch {
      return null;
    }
  }

  function writeStorage(key, value, persistent) {
    try {
      (persistent ? window.localStorage : window.sessionStorage).setItem(key, String(value));
    } catch {
      shownThisPage = true;
    }
  }

  class MusterWelcomePopup extends HTMLElement {
    connectedCallback() {
      this.panel = this.querySelector('.ml-welcome-signup');
      this.closeButton = this.querySelector('.ml-welcome-signup__close');
      if (!this.panel || !this.closeButton || this.initialized) return;
      this.initialized = true;
      this.attempts = 0;
      this.onClose = () => this.dismiss();
      this.onKeyDown = (event) => {
        if (event.key !== 'Escape' || !this.isOpen || this.hasOpenDialog()) return;
        event.preventDefault();
        this.dismiss();
      };
      this.onViewportChange = () => this.updateViewport();
      this.closeButton.addEventListener('click', this.onClose);
      document.addEventListener('keydown', this.onKeyDown);
      window.visualViewport?.addEventListener('resize', this.onViewportChange);
      window.visualViewport?.addEventListener('scroll', this.onViewportChange);
      window.addEventListener('resize', this.onViewportChange);
      this.updateViewport();

      const success = this.querySelector('[id^="MlWelcomeSuccess-"]');
      const error = this.querySelector('[id^="MlWelcomeError-"]');
      if (success) writeStorage(successKey, Date.now() + 180 * day, true);
      if (error || success) {
        this.open(error || success);
      } else if (!window.Shopify?.designMode) {
        this.schedule(8000);
      }
    }

    disconnectedCallback() {
      window.clearTimeout(this.timer);
      this.closeButton?.removeEventListener('click', this.onClose);
      document.removeEventListener('keydown', this.onKeyDown);
      window.visualViewport?.removeEventListener('resize', this.onViewportChange);
      window.visualViewport?.removeEventListener('scroll', this.onViewportChange);
      window.removeEventListener('resize', this.onViewportChange);
      this.initialized = false;
    }

    updateViewport() {
      const viewport = window.visualViewport;
      const height = viewport?.height || window.innerHeight;
      this.panel.style.setProperty('--ml-popup-viewport-height', height + 'px');
      this.panel.style.setProperty('--ml-popup-viewport-top', (viewport?.offsetTop || 0) + 'px');
      this.panel.classList.toggle('ml-welcome-signup--compact-viewport', height < 540);
    }

    schedule(delay) {
      window.clearTimeout(this.timer);
      this.timer = window.setTimeout(() => this.tryOpen(), delay);
    }

    isSuppressed() {
      return this.dataset.knownSubscriber === 'true'
        || shownThisPage
        || readStorage(sessionKey, false) === '1'
        || Number(readStorage(dismissalKey, true)) > Date.now()
        || Number(readStorage(successKey, true)) > Date.now();
    }

    hasOpenDialog() {
      return Array.from(document.querySelectorAll('dialog[open], [aria-modal="true"], details[open][scroll-lock]'))
        .some((dialog) => {
          if (dialog instanceof HTMLDialogElement) return dialog.open;
          if (dialog.closest('[hidden], [aria-hidden="true"]')) return false;
          const style = window.getComputedStyle(dialog);
          return dialog.getClientRects().length > 0
            && style.visibility !== 'hidden'
            && style.visibility !== 'collapse'
            && style.opacity !== '0';
        });
    }

    isBusy() {
      const active = document.activeElement;
      return document.visibilityState !== 'visible'
        || this.hasOpenDialog()
        || (active instanceof HTMLElement && (
          active.matches('input, textarea, select, [contenteditable="true"]')
          || Boolean(active.closest('product-form-component, variant-picker'))
        ));
    }

    tryOpen() {
      if (!this.isConnected || this.isOpen || this.isSuppressed()) return;
      if (this.isBusy()) {
        this.attempts += 1;
        if (this.attempts <= 5) this.schedule(4000);
        return;
      }
      this.open();
    }

    open(feedback) {
      if (this.isOpen) return;
      this.previousFocus = document.activeElement;
      this.isOpen = true;
      shownThisPage = true;
      writeStorage(sessionKey, '1', false);
      this.panel.classList.add('ml-welcome-signup--popup');
      this.panel.setAttribute('role', 'dialog');
      this.panel.setAttribute('aria-modal', 'false');
      this.closeButton.hidden = false;
      this.updateViewport();
      (feedback || this.closeButton).focus({ preventScroll: true });
    }

    dismiss() {
      if (!this.isOpen) return;
      const returnFocus = this.panel.contains(document.activeElement);
      this.isOpen = false;
      writeStorage(dismissalKey, Date.now() + 7 * day, true);
      this.panel.classList.remove('ml-welcome-signup--popup');
      this.panel.removeAttribute('role');
      this.panel.removeAttribute('aria-modal');
      this.closeButton.hidden = true;
      if (returnFocus && this.previousFocus instanceof HTMLElement && this.previousFocus.isConnected) {
        this.previousFocus.focus({ preventScroll: true });
      }
    }
  }

  if (!customElements.get('muster-welcome-popup')) {
    customElements.define('muster-welcome-popup', MusterWelcomePopup);
  }
})();

  } catch(e) { console.error(e); }
})();
})();
